import axios from 'axios';
import base from '@/api/base.api';
const namespace = 'v1/cash-deposit';

export default {
    sendEmailReference: (params) => {
        return axios.post(`${base.baseUrlWallet}/${namespace}/send-email-reference`, params)
    }
}
